/* eslint-disable no-unused-vars */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      ar: {
        translation: {
          "Sign In": "تسجيل الدخول",
          "Shop Code": "كود المتجر",
          "User Name": "اسم المستخدم",
          "Ready to Settle": "جاهز للفوترة",
          "Print Successful": "نجحت الطباعة",
          Password: "الرقم السري",
          Sales: "المبيعات",
          Dashboard: "لوحة البيانات",
          Products: "المنتجات",
          Customer: "العميل",
          Vendors: "البائعون",
          Purchase: "الشراء",
          Inventory: "الشراء",
          Accounts: "الحسابات",
          Analytics: "التحليلات",
          Reports: "التقارير",
          Settings: "الإعدادات",
          Logout: "تسجيل الخروج",
          "Refresh Data": "تحديث البيانات",
          "Add Product": "إضافة منتج",
          Code: "الكود",
          Name: "الاسم",
          Department: "القسم",
          Vendor: "البائع",
          Price: "السعر",
          Actions: "الإجراءات",
          "Product List": "قائمة المنتجات",
          "New Product": "منتج جديد ",
          Quantity: "الكمية",
          Weight: "الوزن",
          "Tax is Required": "الضريبة المطلوبة",
          "Unit Type Required": "نوع الوحدة مطلوب",
          "Barcode Required": "الرمز الشريطي مطلوب",
          "Duplicate barcode": "مضاعفة الرمز الشريطي",
          "Factor should be greater than Zero":
            "يجب أن يكون العامل أكبر من الصفر",
          "Item code can not be same as barcode":
            " يجب أن يختلف رمز العنصر عن الرمز الشريطي",
          "Barcode Can not be Same as Item Code":
            "يجب أن يختلف رمز العنصر عن الرمز الشريطي",
          "Short Name": "الاسم المختصر ",
          "Local Name": "الاسم المحلي ",
          "Sub Department": "الفئة الفرعية ",
          Category: "الفئة",
          "Sub Category": "الفئة الفرعية",
          Tax: "الضرائب",
          "Deli UOM": "وحدة قياس الديلي",
          Symbol: "الرمز",
          "Current Stock": "المخزون الحالي",
          "Is Discounted": "هل يوجد خصم",
          "Is Open Price": "هل السعر مفتوح",
          "Discount in Price": "خصم في السعر",
          "Tax in Price": "الضرائب مشمولة في السعر",
          "Is Fastitem": "فست آیتم",
          "Is Open Quantity": "هل الكمية مفتوحة",
          "Is Stock Item": "هل البند (العنصر) من المخزون",
          Pricing: "التسعير",
          "Kit Items": "عناصر المجموعة",
          "Margin [RSP-Cost-Tax]": "الهامش [RSP-Cost-Tax]",
          "Actual Price": "السعر الفعلي",
          "Promotion Amount": "مبلغ الترويج",
          "Tax Amount [RSP x Tax%]": "مبلغ الضريبة [RSP x Tax%]",
          "Retail Sale Price": "سعر البيع بالتجزئة",
          "Name is Required": "الاسم مطلوب",
          "Code is Required": "الكود مطلوب",
          "Department is Required": "القسم مطلوب",
          "Vendor is Required": "البائع مطلوب",
          "Deliitem UOM is Required": "وحدة قياس ديل مطلوب Deliitem UOM ",
          "Unit symbol is Required": "رمز الوحدة مطلوب",
          "Currentstock is Required": "المخزون الحالي مطلوب",
          "Not able to retrive Product data from server":
            "غير قادر على استعادة بيانات المنتج من الخادم",
          "Are You Sure": "هل أنت متأكد",
          "Are you sure to delete product": "هل أنت متأكد من حذف المنتج",
          Product: "المنتج",
          "got Removed": "تم إزالته",
          "Not able to Delete Product": "غير قادر على حذف المنتج ",
          "Saved Successfully": "تم حفظة بنجاح ",
          "Not able to Save Product": "غير قادر على حفظ المنتج",
          "Validation Failed": "فشل التحقق من الصحة",
          "Departmant is Required": "القسم مطلوب",
          "Looking for Agent...": "البحث عن وكيل",
          "Agent not Found. Please install agent":
            "الوكيل غير موجود يُرجى تثبيت الوكيل",
          "Print format is empty": " تنسيق الطباعة فارغ",
          "Shelf label print format not found":
            "تنسيق طباعة ملصق الرف غير موجود",
          "Configuration error": "خطأ في التكوين",
          "Barcode print format not found":
            "تنسيق طباعة الرمز الشريطي غير موجود",
          Format: "التنسيق",
          "Printer Configuration": "تكوين الطابعة",
          Count: "الحساب",
          "Shelf Label": "ملصق الرف",
          "Print Barcode": "طباعة الرمز الشريطي",
          "Barcode Print": " الرمز الشريطي للطباعة",
          "Install Agent": "تثبيت الوكيل",
          SN: "رقم التسلسل",
          "Product Name": "اسم المنتج",
          "Product Code": "كود المنتج ",
          Barcode: "الرمز الشريطي",
          Action: "الإجراء",
          "Remove Item": "عنصر الإزالة",
          Promotions: "عمليات الترويج",
          "Price with Tax & %": " السعر مع الضريبة والنسبة المئوية ٪",
          "Price with Tax ": " السعر مع الضريبة ",
          "Price with % ": " السعر مع النسبة المئوية ",
          "Price w/o Tax & %": " السعر مع الضريبة والنسبة المئوية ٪",
          "Unit Type": "نوع الوحدة",
          Factor: "العنصر",
          Cost: "التكلفة",
          "Margin %": "الهامش %",
          Margin: "الهامش",
          Barcodes: "الرموز الشريطية",
          "Price Card": "بطاقة السهر",
          "Margin [RSP - Cost - Tax]": "الهامش [RSP-Cost-Tax]",
          Level: "المستوى",
          "Price W/O Tax": "السعر مع الضريبة",
          "Product pricing levels": "مستويات تسعير المنتج",
          New: "جديد",
          "View List": "عرض القائمة",
          "Request Entry": "طلب الدخول ",
          "Return Entry": "إعادة الدخول ",
          Multiple: "التضعيف",
          "Item Wise": "البند الحكيم",
          "Order Id": "رقم الطلب",
          Date: "التاريخ",
          "Invoice Number": "رقم الفاتورة",
          View: "العرض",
          Edit: "التعديل",
          Settle: "التسوية",
          "Purchase Return List": "قائمة عودة الشراء",
          Print: "طباعة",
          "Purchase Request List": "قائمة طلب الشراء",
          "Create Quick Purchase": " إجراء شراء سريع",
          return: "الإعادة",
          order: "الطلب",
          "View QuickPurchase": "عرض شراء سريع",
          "Edit Quick Purchase": "تعديل شراء سريع",
          "Not able to retrive purchase order data from server":
            "غير قادر على استعادة بيانات أمر الشراء من الخادم",
          "Purchase order settled sucessfully": "تمت تسوية أمر الشراء بنجاح",
          "Not able to settle Purchase Order": "غير قادر على تسوية أمر الشراء",
          "Validation failed": "فشل التحقق من الصحة",
          "Validation failed, Quantity is worng at row":
            "Validation failed, Quantity is worng at row",
          "Validation failed, Cost is worng at row":
            "Validation failed, Cost is worng at row",
          "Toatl Quantity": "إجمالي الكمية",
          "Toatl W/O Tax": "الإجمالي مع الضريبة",
          "Toatl Tax": "إجمالي الضريبة",
          "Toatl With Tax": "الإجمالي مع الضريبة",
          "Reference number is required": "رقم المرجع مطلوب ",
          "Vendor is required": "البائع مطلوب",
          "Payment mode is required": "طريقة الدفع مطلوبة",
          "Payment terms is required": "بنود الدفع مطلوبة",
          "Invoice Number is required": "رقم الفاتورة مطلوب",
          "Transaction date is required": " بيانات المعاملة مطلوبة ",
          "Purchase request attachment": "مرفق طلب الشراء",
          "Referene No": "رقم المرجع",
          "Invoice No": "رقم الفاتورة",
          "Payment Mode": "طريقة الدفع ",
          "Payment Terms": "شروط الدفع ",
          Account: "الحساب",
          Note: "الإيضاح",
          Attachment: "المرفق",
          Change: "التغيير",
          Upload: "تحميل",
          Unit: "الوحدة",
          "Received Qty": "الكمية المستلمة ",
          "Received Cost": "التكلفة المستلمة",
          "Tax %": "الضرائب %",
          "Tax Cost": "تكلفة الضريبة ",
          "Cost without Tax": "التكلفة من دون التكلفة",
          "Final Cost": "التكلفة النهائية",
          "Remove Pricing": "إزالة التسعير",
          "Product Lookup": " البحث عن المنتج ",
          Consolidated: " الموحدة",
          "With Tax": "مع الضريبة",
          "Expected date is required": "البيانات المتوقعة مطلوبة",
          "Referenenumber is Required": "رقم المرجع مطلوب ",
          "Vendorbean is Required": "البائع مطلوب",
          "Paymentmode is Required": "طريقة الدفع مطلوب",
          "Paymentterms is Required": "بنود الدفع مطلوبة",
          "Ref. No": "رقم المرجع ",
          "Exp. Date": "تاريخ الانتهاء التاريخ ",
          Create: "الإنشاء",
          Return: "الإرجاع",
          "Sale Return": "الإرجاع",
          Settlement: "التسوية",
          "View Purchase": "عرض الشراء",
          "Something went wrong! View mode is undefined":
            "هناك شيء خاطئ! عرض الطريقة غير مُحدد ",
          "Settled Sucessfully": "تمت التسوية بنجاح",
          "Updated Successfully": "التحديث بنجاح",
          "Not able to Save Purchase Order": "غير قادر على حفظ أمر الشراء",
          "Received Qantity": "الكمية المستلمة",
          "Not able to Save Stock Adjustment":
            "غير قادر على حفظ تعديلات المخزون",
          "Item Code": "كود العنصر",
          Reason: "السبب",
          "Item Name": "اسم العنصر",
          "New Stock": "المخزون الجديد",
          "Reason Descreption": "وصف السبب",
          "Stock Adjustment": "تعديل المخزون",
          "Product alredy exists": "المنتج الموجود فعليًا",
          Descreption: "الوصف",
          "Inventory Adjustment List": "قائمة تعديل المخزون",
          "Purchase Order": "أمر الشراء",
          "Purchase Return": "عودة الشراء",
          "Quick Entry": " الإدخال السريع",
          "Inventory Adjustment": " تعديل المخزون ",
          GRN: "  إشعار استلام البضائع GRN",
          GRV: "  إشعار ارسال البضائع GRV",
          "Price Check": "فحص السعر",
          Sync: "المزامنة",
          "Log Out": "تسجيل الخروج",
          Version: "الإصدار",
          "Device Id": "رقم الجهاز",
          User: "المستخدم",
          Configure: "تهيئة",
          Setting: "الضبط",
          Download: "التحميل",
          "Remove Product": "إزالة المنتج",
          "Expected Date": " التاريخ المتوقع",
          "Please select atleast one product to proceed":
            "يرجى تحديد منتج واحد على الأقل للمتابعة",
          "Shelf Label Format": " تنسيق ملصق الرف ",
          "Barcode Format": "تنسيق الرمز الشريطي",
          "Purchase Entry": "شراء الإدخال",
          LPO: "أمر الشراء المحلي",
          Request: "الطلب",
          "Reason is Required": "السبب مطلوب",
          "Descreption is Required": "الوصف مطلوب",
          "Please select product before proceed":
            "الرجاء تحديد المنتج قبل المتابعة",
          "New stock is Required": "المخزون الجديد مطلوب",
          "Order Type": "نوع الطلب ",
          Status: "الحالة",
          "View Quick Purchase": "عرض شراء سريع",
          "Purchase order saved as draft": "حفظ أمر الشراء كمسودة",
          "No products selected for settle": "لا توجد منتجات محددة للتسوية",
          "eSale POS": " نقاط البيع بالتجزئة الإلكترونية (eSale) ",
          "Retail Cloud": "سحابة البيع بالتجزئة",
          "Sale Summary": "ملخص البيع",
          "Pay Code": "كود الدفع",
          "Ex Rate": "معدل الانتهاء",
          "Net Sales": "صافي المبيعات",
          Total: "الإجمالي",
          "Not able to find Active Sale Session":
            "غير قادر على العثور على جلسة بيع نشطة",
          "Device ": "الجهاز  ",
          "New Sale": "بيع جديد",
          "Day Open": "اليوم المفتوح ",
          "Day Close": "إغلاق اليوم",
          "Journal Entries": "إدخالات دفتر اليومية",
          "Manage Journal Records": "إدارة سجلات دفتر اليومية",
          Payments: "المدفوعات",
          "Manage Payments": "إدارة المدفوعات",
          Receipts: "الإيصالات",
          "Manage Receipts": "إدارة الإيصالات",
          Ledgers: "دفاتر الأستاذ",
          "Accounts Settings": "إعدادات الحسابات",
          "Purchase Orders": "أوامر الشراء",
          Invoices: "الفواتير",
          Customers: "العملاء",
          "Printer Configuration Saved": "تكوين الطابعة المحفوظ",
          "Printer Name is Required": "اسم الطابعة مطلوب",
          "Agent IP is Required": "عنوان IP للوكيل مطلوب",
          "Network Printer": "طابعة الشبكة",
          "Agent IP": "عنوان IP للوكيل ",
          "Agent Lookup": "بحث عن وكيل",
          Printer: "طابعة",
          "Configure Printer": "تكوين الطابعة",
          Save: "حفظ",
          "Download Agent": "وكيل التحميل",
          "Configure Terminal": "تكوين المحطة",
          "Terminal Information saved...": " تم حفظ معلومات المحطة ",
          "Downloading...": "جاري التحميل ..... ",
          "Downlaod Failed, Try Again": "فشل التحميل ......... حاول مرة أخرى",
          "Terminal key": "مفتاح المحطة",
          "Receipt Printer": "طابعة الإيصال",
          "Barcode Printer": "طابعة الرمز الشريطي",
          "Pole Display": "عرض القطب ",
          "Report Printer": "تقرير الطابعة",
          "Self Label Printer": "طابعة ملصقات ذاتية",
          Generating: "الإنشاء",
          Generate: "ينشئ",
          "Customer is Required": "العميل مطلوب",
          "Amount is Required": "المبلغ مطلوب",
          "Payment mode is Required": "طريقة الدفع مطلوبة",
          "Reasoncode is Required": "كود السبب مطلوب",
          "Not able to retrive Payin data from server":
            "غير قادر على استعادة التوريد من الخادم ",
          "Customer Payin Report": "تقرير التوريد للعميل",
          "Reason code is Required": "كود السبب مطلوب",
          "Payout Reason": "سبب الدفع",
          "Customer Lookup": "البحث عن العملاء",
          Amount: "المبلغ",
          Description: "الوصف",
          "Add Payin": "أضف التوريد",
          "Payin List": "قائمة التوريد",
          "Group code is Required": "كود المجموعة مطلوب",
          "Not able to retrive Category data from server":
            "غير قادر على استعادة بيانات الفئة من الخادم",
          "Are you sure to delete category": "هل أنت متأكد من حذف الفئة",
          "Not able to Save Category": "غير قادر على حفظ الفئة ",
          "Category Code": "كود الفئة",
          "Group code": "كود المجموعة",
          Promotion: "الترويج",
          "Category List": " قائمة الفئة ",
          Delete: "الحذف",
          "Micr Code": "كود مايكرو",
          "Credit Limit": "حد الائتمان",
          "Select Customer": "حدد العميل",
          "Micrcode is Required": "كود مايكرو مطلوب",
          "Mobile is Required": "رقم الجوال مطلوب",
          "Trn is Required": "رقم التسجيل الضريبي مطلوب",
          "Not able to Save Customer": "غير قادر على حفظ العميل",
          "Credit limit is Required": "حد الائتمان مطلوب",
          "Opening due amount is Required": " مبلغ الافتتاح المستحق مطلوب",
          "Should not exeed credit limit": "لا يجب تجاوز حد الائتمان",
          Mobile: "جوال",
          Email: "بريد إلكتروني",
          "Email Invoice": "فاتورة البريد الإلكتروني",
          "SMS Invoice": "فاتورة الرسائل القصيرة",
          Trn: "رقم التسجيل الضريبي",
          "Is Credit Customer": "عميل دائن",
          "Day Limit": "حد اليوم ",
          "Opening Amount": "مبلغ الافتتاح",
          Update: "التحديث",
          Proceed: "التقديم",
          "Quantity and Cost": "الكمية والتكلفة",
          "Discount Limit Exceeds": "تجاوز حد الخصم",
          "Discount value": "قيمة الخصم",
          Percentage: "النسبة المئوية",
          Flat: "المستوى",
          "Apply Discount": "تطبيق الخصم",
          "You are not allowed to apply discount": "لا يسمح لك بتطبيق الخصم",
          CASH: "الدفع نقدا",
          CARD: "الدفع ببطاقة",
          "Value required": "القيمة المطلوبة ",
          "Customer Name": "اسم العميل ",
          Discount: "الخصم:",
          "Settle & Print": "التسوية والطباعة",
          "Agent not Found. Try to Restart the App":
            "الوكيل غير متوفر حاول إعادة تشغل التطبيق",
          "Active Sale Session found, Please resume sale activity.":
            "تم العثور على جلسة بيع نشطة",
          "No active Sale Session found , Start new Sale Session now.":
            "لم يتم العثور على جلسة بيع نشطة ",
          Retry: "إعادة المحاولة",
          "Start Sale": "بدء البيع",
          "Resume Sale": "استئناف البيع",
          "Close Sale": "غلق البيع",
          "Is Deli Item": "عنصر ديلي",
          "New Customer": "عميل جديد",
          "Customer Id is Required": "رقم العميل مطلوب",
          "Micr code is Required": "كود المجموعة مطلوب",
          "Address1 is Required": "العنوان 1 مطلوب",
          "Phone is Required": "الهاتف مطلوب",
          "Mobile Number is Required": "رقم الجوال مطلوب",
          "Not able to retrive Customer data from server":
            "غير قادر على استعادة بيانات العميل من الخادم",
          "Are you sure to delete customer": "هل أنت متأكد من حذف العميل",
          "Not able to Delete Customer": "غير قادر على حذف العميل",
          "Customer id is Required": "رقم العميل مطلوب",
          "Mobile number is Required": "رقم الجوال مطلوب",
          "Credit policy is Required": "سياسة الائتمان مطلوبة",
          "Customer group is Required": "مجموعة العميل مطلوبة",
          Id: "الهوية",
          Group: "المجموعة",
          "Pricing Level": "مستوى التسعير",
          "Address 1": "العنوان1",
          Street: "الشارع",
          Zip: "الكود البريدي",
          City: "المدينة",
          State: "الدولة",
          "Date of Birth": "تاريخ الميلاد",
          "Address 2": "العنوان 2",
          Phone: "هاتف",
          "Second Customer Name": "اسم العميل الثاني",
          "Third Customer Name": "اسم العميل الثالث",
          "Fourth Customer Name": "اسم العميل الرابع",
          "Second Customer Contact": "جهة اتصال العميل الثاني",
          "Third Customer Contact": "جهة اتصال العميل الثالث",
          "Fourth Customer Contact": "جهة اتصال العميل الرابع",
          "Basic Details": "البينات الأساسية",
          "More Details": "مزيد من البيانات",
          "Id proof": "إثبات الهوية",
          "Customer Group": "مجموعة العملاء",
          "Add Customer": "إضافة عميل ",
          "Pay In": "الدفع في",
          "No Customer is Selected": "لم يتم تحديد أي عميل",
          "Do you want to continue": "هل ترغب في الاستمرار",
          "Customer Selected": "تم تحديد العميل",
          "Loyality Points": "نقاط الولاء ",
          "Due Amount": "المبلغ المستحق",
          "Last Purchace Date": "تاريخ آخر عملية شراء",
          "Available Credit": "الائتمان المتوفر",
          Select: "الاختيار",
          "Customer Selection": "اختيار العميل",
          ID: "الهوية",
          Micr: "مايكر Micr",
          "Customer List": "قائمة العميل",
          "Not able to retrive Customer group data from server":
            " غير قادر على استعادة بيانات مجموعة العميل من الخادم ",
          "Are you sure to delete customer group":
            "هل أنت متأكد من حذف مجموعة العميل",
          "Customer group": "مجموعة العميل",
          "Not able to Delete Customer group": "غير قادر على حذف مجموعة العميل",
          "Not able to Save Customer group": "غير قادر على حفظ مجموعة العميل",
          "Add Customergroup": "إضافة مجموعة العميل",
          "Group Code": "كود المجموعة",
          "Customer group List": "قائمة مجموعة العميل",
          "New Customer transaction": "معاملة عميل جديد",
          "Not able to retrive Customer transaction data from server":
            "غير قادر على استعادة بيانات معاملة عميل جديد من الخادم ",
          "Are you sure to delete customertransaction":
            "هل أنت متأكد من حذف معاملة العميل",
          "Customer transaction": "معاملة العميل",
          "Not able to Delete Customer transaction":
            "غير قادر على حذف معاملة العميل",
          "Not able to Save Customer transaction":
            "غير قادر على حفظ معاملة العميل",
          "Customer Transactions": "معاملات العميل",
          "Voucher Number": "رقم قسيمة الدفع",
          "Error!": "خطأ!",
          "Error while Printing, Check your Printer is paired":
            "خطأ أثناء الطباعة",
          "Please add some items": " يُرجى إضافة بعض العناصر",
          Error: "خطأ",
          "Not Able to Save Sale": "غير قادر على حفظ البيع",
          Payment: "الدفع",
          PRICE: "السعر",
          "DISC%": "الوصف %",
          Enter: "الإدخال",
          DISC$: "مبلغ الوصف $",
          No: "لا",
          Yes: "نعم",
          "Duplicate Invoice ?": "هل هي فاتورة مكررة؟",
          "Hold Sale": "عقد البيع",
          "Sale Holded": "تم عقد البيع ",
          "Price can't be empty": "لا يجوز أن يكون السعر فارغًا",
          "Open Price": "سعر الفتح",
          Apply: "التطبيق",
          "Please Enter Price": "يُرجى إدخال السعر",
          "Please Enter Quantity": "يُرجى إدخال الكمية",
          "Please Enter Amount": "يُرجى إدخال المبلغ ",
          "Enter Quantity": "إدخال الكمية",
          RETURN: "الإعادة",
          DRAWER: "السحب",
          REPRINT: "إعادة الطباعة",
          PAYIN: "التوريد ",
          PAYOUT: "الصرف",
          VOID: "فارغ",
          HOLD: "معلق",
          UNHOLD: "غير معلق",
          HISTORY: "السجل",
          PAYMENT: "الدفع",
          Items: "العناصر",
          "Looking for Agent": "البحث عن وكيل ",
          "Please Download and Install Agent": "يُرجى تحميل وتثبيت الوكيل ",
          Downloading: "التحميل",
          "Product Not Found": "المنتج غير متوفر",
          "S/N": "س/ن",
          UOM: "وحدة القياس",
          Qty: "الكمية",
          "Disc%": " نسبة الوصف %",
          "Search or Scan the product": "البحث عن المنتج أو مسحة ضوئيًا",
          Summary: "الملخص",
          "No Items": "رقم العناصر",
          "Amount Ex Tax": "مبلغ الضريبة الداخلية",
          "After Discount": "بعد الخصم",
          "Alert!": "تنويه!",
          "Not Able to Hold Sale": "غير قادر على عقد البيع",
          "Search For Product": "البحث عن المنتج",
          "Hold List": " قائمة الانتظار",
          "Hold note": "ملحوظة الانتظار",
          " Hold List": " قائمة الانتظار",
          "To Pay": "الدفع ",
          Settled: "تم الفوترة",
          CREDIT: "الائتمان",
          DISCOUNT: "الخصم",
          "Credit Payment Date Expired!": "انتهاء تاريخ دفع الائتمان!",
          Type: "الحساب",
          "Credit Amount": "مبلغ الاعتماد",
          "Debit Amount": "مبلغ الخصم",
          Mode: "الطريقة",
          "Not enough credit, Balance to Pay": "لا يوجد ائتمان كافي",
          "Cash in Hand": "النقود الحاضرة ",
          "Cash Summary": "ملخص النقود",
          "Net Amount": "إجمالي المبلغ",
          "Day Close Summary": "ملخص إغلاق اليوم",
          "Dept Code Length": "طول كود القسم",
          "Item Code Length": "طول كود العنصر",
          "Value Length": "طول القيمة",
          "Parity Length": "طول التكافؤ",
          "Item Code Length Should be Greater than Zero":
            "يجب أن يكون طول رمز العنصر أكبر من الصفر",
          "Item Code Length Should be Less than Ten":
            "يجب أن يكون طول رمز العنصر أقل من عشرة",
          "Item Code Length is required": "طول كود العنصر مطلوب",
          "Dept Code Length Should be Greater than Zero":
            "يجب أن يكون طول رمز القسم أكبر من الصفر",
          "Dept Code Length Should be Less than 3":
            "يجب أن يكون طول رمز القسم أقل من 3",
          "Dept Code Length is required": "طول كود القسم مطلوب",
          "Value Length Should be Greater than Zero":
            "يجب أن يكون طول القيمة أكبر من الصفر",
          "Value Length Should be Less than Ten":
            "يجب أن يكون طول القيمة أقل من عشرة",
          "Value Length is required": "طول القيمة مطلوب",
          "Parity Length Should be Greater than Zero":
            "يجب أن يكون طول التكافؤ أكبر من الصفر",
          "Parity Length Should be Less than 2":
            "يجب أن يكون طول التكافؤ أقل من 2",
          "Parity Length is required": "طول التكافؤ مطلوب",
          "Deli Item Settings": "إعدادات عنصر ديلي",
          "Product Settings": "إعدادات المنتج",
          "Day Open/Close flow": "وم فتح / إغلاق التدفق",
          "Receipt Print": "طباعة الإيصال",
          "Include Tax in adjusted Price": "تضمين الضريبة في السعر المعدل",
          "Apply discount on Final Price": "تطبيق الخصم على السعر النهائي",
          "Direct Settlement without Payment popup":
            "تسوية مباشرة بدون دفع منبثق",
          "Duplicate Invoice Prompt": "محاولة تكرار فاتورة ",
          "Block purchases exeeding credit limit":
            "منع المشتريات التي تتجاوز حد الائتمان",
          "Block purchases exeeding Due date":
            "منع المشتريات التي تجاوزت تاريخ الاستحقاق",
          "Pole Display Welcome Message Line 1": "عرض قطب خط رسالة الترحيب 1",
          "Pole Display Welcome Message Line 2": "عرض قطب خط رسالة الترحيب 2",
          "Sale Settings": "إعدادات البيع",
          Store: "المتجر",
          Configurations: "التكوينات",
          Security: "الحماية",
          "Store Name": "اسم المتجر",
          "Store Email": "بريد المتجر",
          "Email Password": "كلمة مرور البريد الإلكتروني",
          "Email Host": "مضيف البريد الإلكتروني",
          "Email Port": "منفذ البريد الإلكتروني",
          "Store Details": "تفاصيل المتجر",
          "Store Settings": "إعدادات المتجر",
          "New Configuration": "التكوين الجديد",
          "Configuration is Required": "التكوين مطلوب",
          "Legends is Required": "ليجندز مطلوب",
          "Not able to retrive Config data from server":
            "غير قادر على استعادة بيانات التكوين من الخادم",
          "Are you sure to delete configuration": "هل أنت متأكد من حذف التكوين",
          Configuration: "التكوين",
          "Not able to Delete Configuration": "غير قادر على حذف التكوين",
          "Not able to Save Configuration": "غير قادر على حفظ التكوين ",
          "Configtxt is Required":
            " استكشاف الأخطاء وإصلاحها في Config.txt مطلوب",
          "Config Text": "تكوين النص",
          Legends: "الأساطير",
          "Config List": "قائمة التكوين",
          "Password is required": "كلمة المرور مطلوبة",
          "Confirm password is required": "تأكيد كلمة المرور مطلوب",
          "Not able to Save User": "غير قادر على حفظ المستخدم",
          "Password must contain 8 digit":
            "يجب أن تحتوي كلمة المرور على 8 أرقام",
          "Confirm password and New password should be same":
            "تأكيد كلمة المرور يجب أن تكون كلمة المرور الجديدة متطابقة",
          "New Password": "كلمة السر الجديدة",
          "Confirm Password": "تأكيد كلمة المرور",
          Users: "المستخدمون",
          Roles: "الأدوار",
          "My Profile": "ملفي",
          "New Role": "دور جديد",
          "Not able to retrive Role data from server":
            "غير قادر على استعادة بيانات الدور من الخادم",
          "Are you sure to delete role": "هل أنت متأكد من حذف الدور",
          Role: " الدور",
          "Not able to Delete Role": "غير قادر على حذف الدور",
          "Not able to Save Role": "غير قادر على حفظ الدور",
          "Add Role": "أضف دورًا",
          "Role List": "قائمة الأدوار",
          "New User": "مستخدم جديد",
          "Username is Required": "اسم المستخدم مطلوب",
          "Password is Required": "كلمة المرور مطلوبة",
          "Not able to retrive User data from server":
            "غير قادر على استعادة بيانات المستخدم من الخادم",
          "Are you sure to delete user": "هل أنت متأكد من حذف المستخدم",
          "Not able to Delete User": "غير قادر على حذف المستخدم",
          Contact: "جهة الاتصال",
          "Current Address": "العنوان الحالي",
          "Permanent Address": "العنوان الثابت",
          "Add User": "إضافة مستخدم",
          "User List": "قائمة المستخدم ",
          "New Tax": "ضريبة جديدة",
          "Rate is Required": "السعر مطلوب",
          "Not able to retrive Tax data from server":
            "غير قادر على استرداد البيانات الضريبية من الخادم",
          "Are you sure to delete tax": "هل أنت متأكد من حذف الضرائب",
          "Not able to Delete Tax": "غير قادر على حذف الضرائب",
          "Not able to Save Tax": "غير قادر على حفظ الضرائب",
          Rate: "المعدل",
          "Add Tax": " أضف ضريبة",
          "New Terminal": "محطة جديدة",
          "Device id is Required": "رقم الجهاز مطلوب",
          "invoice Prefix is Required": "بادئة الفاتورة مطلوبة",
          "Not able to retrive Terminal data from server":
            "غير قادر على استعادة بيانات المحطة من الخادم",
          "Are you sure to delete terminal": "هل أنت متأكد من حذف المحطة",
          Terminal: "المحطة",
          "Not able to Delete Terminal": "غير قادر على حذف المحطة",
          "Not able to Save Terminal": "غير قادر على حفظ المحطة",
          "Terminal Key": "مفتاح المحطة",
          "Receipt printer": "طابعة الإيصال",
          "Pole Display Port": "منفذ عرض القطب",
          "Device id": "رقم الجهاز",
          "Invoice Prefix": "بادئة الفاتورة",
          Features: "المميزات",
          Sale: "البيع",
          "Receipt Config": "تكوين الإيصال",
          "Day Open Config": "تكوين اليوم المفتوح",
          "Day Close Config": "تكوين إغلاق اليوم",
          "Payin Config": "تكوين التوريد",
          "Payout Config": "تكوين الدفع",
          "Add Terminal": "إضافة محطة",
          Terminals: "المحطات",
          "Contact is Required": "جهة الاتصال مطلوبة",
          "Address is Required": "العنوان مطلوب",
          "Not able to retrive Vendor data from server":
            "غير قادر على استعادة بيانات البائع من الخادم ",
          "Are you sure to delete vendor": "هل أنت متأكد من حذف البائع",
          "Not able to Delete Vendor": "غير قادر على حذف البائع",
          "Not able to Save Vendor": "غير قادر على حفظ البائع ",
          Address: "العنوان",
          "Add Vendor": "إضافة بائع",
          "TRN Number": "رقم تسجيل الضريبة",
          "Vendor List": "قائمة البائع",
          Balance: "الرصيد",
          Login: "Login",
          "File Seletor": "File Seletor",
          "File Viewer": "File Viewer",
          Success: "Success",
          "General Payment Voucher": "General Payment Voucher",
          "General Receipt Voucher": "General Receipt Voucher",
          "Manage Customer Transactions": "Manage Customer Transactions",
          "Vendor Transactions": "Vendor Transactions",
          "Manage Vendor Transactions": "Manage Vendor Transactions",
          "Chart of Accounts": "Chart of Accounts",
          "Dash Board": "Dash Board",
          "Journal Records": "Journal Records",
          Receipt: "Receipt",
          "Default Bank for Sale": "Default Bank for Sale",
          "General Settiings": "General Settiings",
          "New Accounting Settings": "New Accounting Settings",
          "Select Account nature": "Select Account nature",
          "Ledger is Required": "Ledger is Required",
          "OpeningBalance is Required": "OpeningBalance is Required",
          "Not able to retrive Accounting Settings data from server":
            "Not able to retrive Accounting Settings data from server",
          "Are you sure to delete accounting settings":
            "Are you sure to delete accounting settings",
          "Accounting Settings ": "Accounting Settings ",
          " got Removed": " got Removed",
          "Not able to Delete Accounting Settings":
            "Not able to Delete Accounting Settings",
          "Not able to Save Accounting Settings":
            "Not able to Save Accounting Settings",
          "Select nature of Account": "Select nature of Account",
          "Opening Balance is Required": "Opening Balance is Required",
          Ledger: "Ledger",
          "Opening Balance": "Opening Balance",
          "Account Nature": "Account Nature",
          "Bank Name": "Bank Name",
          "Account Number": "Account Number",
          "Branch Name": "Branch Name",
          "IBAN/IFSC": "IBAN/IFSC",
          Currency: "Currency",
          "Chart Of Accounts": "Chart Of Accounts",
          General: "General",
          Nature: "Nature",
          "New Sub Ledger": "New Sub Ledger",
          "Accounting Dashboard": "Accounting Dashboard",
          "New chart": "New chart",
          "New Ledger": "New Ledger",
          "Edit Chart": "Edit Chart",
          Advance: "Advance",
          Full: "Full",
          "Are you sure to delete transactions":
            "Are you sure to delete transactions",
          "customer Transaction": "customer Transaction",
          "Not able to Save Transactions": "Not able to Save Transactions",
          "Account is Required": "Account is Required",
          "Amount Payed is Required": "Amount Payed is Required",
          "Payed is Required": "Payed is Required",
          "Transaction date is Required": "Transaction date is Required",
          "No Payments pending": "No Payments pending",
          "Payments pending": "Payments pending",
          "Cheque No": "Cheque No",
          "Total to Pay": "Total to Pay",
          "To pay": "To pay",
          Payed: "Payed",
          Remarks: "Remarks",
          "Add Cash Transaction": "Add Cash Transaction",
          "Add Bank Transaction": "Add Bank Transaction",
          From: "From",
          To: "To",
          "Please add journal entry before proceed!":
            "Please add journal entry before proceed!",
          "Please select Ledger for row": "Please select Ledger for row",
          "Debit/Credit amount can not be empty at row: ":
            "Debit/Credit amount can not be empty at row: ",
          Credit: "Credit",
          Debit: "Debit",
          Remove: "Remove",
          "Create edit Journal Entry": "Create edit Journal Entry",
          "New Journal Entry": "New Journal Entry",
          "Ledger Name": "Ledger Name",
          "Ledger Code": "Ledger Code",
          "Journal Entry List": "Journal Entry List",
          "New Transactions": "New Transactions",
          Completed: "Completed",
          Pending: "Pending",
          "Voucher Number is Required": "Voucher Number is Required",
          "From Ledger is Required": "From Ledger is Required",
          "To Ledger is Required": "To Ledger is Required",
          "Payer name is Required": "Payer name is Required",
          "Payee name is Required": "Payee name is Required",
          "Status is Required": "Status is Required",
          "Not able to retrive Transactions data from server":
            "Not able to retrive Transactions data from server",
          "Transactions ": "Transactions ",
          "Not able to Delete Transactions": "Not able to Delete Transactions",
          "Accounts Transaction": "Accounts Transaction",
          "From Account": "From Account",
          "To Account": "To Account",
          "Transaction Date": "Transaction Date",
          Payer: "Payer",
          Payee: "Payee",
          "Reference Number": "Reference Number",
          "Accounts Summary": "Accounts Summary",
          Cash: "Cash",
          Bank: "Bank",
          "vendor is Required": "vendor is Required",
          "Payment type Required": "Payment type Required",
          "Not able to retrive any Bank accounts":
            "Not able to retrive any Bank accounts",
          "Not able to retrive any accounts":
            "Not able to retrive any accounts",
          "Vendor Cash Voucher": "Vendor Cash Voucher",
          "Vendor Bank Voucher": "Vendor Bank Voucher",
          "Not able to retrive Vendor account from server":
            "Not able to retrive Vendor account from server",
          "Transactiondate is Required": "Transactiondate is Required",
          "Order Date": "Order Date",
          "Vendor Transaction List": "Vendor Transaction List",
          Categories: "Categories",
          "Edit Department": "Edit Department",
          "Edit Sub Department": "Edit Sub Department",
          "Edit Category": "Edit Category",
          "Edit Sub Category": "Edit Sub Category",
          "Add Sub Department": "Add Sub Department",
          "Add Category": "Add Category",
          "Add Sub Category": "Add Sub Category",
          "Add Department": "Add Department",
          Payin: "Payin",
          "Daily Sales": "Daily Sales",
          "Daily Purchases": "Daily Purchases",
          "Last 10 Days Invoices": "Last 10 Days Invoices",
          Agent: "Agent",
          "Search Printer": "Search Printer",
          "Image Printer": "Image Printer",
          "Search Pole Display": "Search Pole Display",
          Service: "Service",
          "Sale Return": "Sale Return",
          "Email is Required": "Email is Required",
          "MICR code is Required": "MICR code is Required",
          "TRN is Required": "TRN is Required",
          "Day limit is Required": "Day limit is Required",
          "Opening amount is Required": "Opening amount is Required",
          "MICR Code": "MICR Code",
          TRN: "TRN",
          "Credit Customer": "Credit Customer",
          "Edit Customer": "Edit Customer",
          "View Edit": "View Edit",
          "Clear Cache": "Clear Cache",
          "Error while fetching order data": "Error while fetching order data",
          "Discount limit exceeds": "Discount limit exceeds",
          "Discount applied sucessfully": "Discount applied sucessfully",
          "Error while fetching privileges": "Error while fetching privileges",
          "Something went wrong": "Something went wrong",
          "Maximum applicable discount limit exceeds":
            "Maximum applicable discount limit exceeds",
          "Discount not allowed by privillage":
            "Discount not allowed by privillage",
          "Something went wrong while apply discount":
            "Something went wrong while apply discount",
          "Login failed": "Login failed",
          "Custom field validation failed": "Custom field validation failed",
          "Proceed Payment": "Proceed Payment",
          "Not able to retrive sale history from server":
            "Not able to retrive sale history from server",
          "Not able to retrive sale data from server":
            "Not able to retrive sale data from server",
          "Sale item note": "Sale item note",
          "Update sale item QTY": "Update sale item QTY",
          "Update sale item PRICE": "Update sale item PRICE",
          "Change QTY": "Change QTY",
          "Change PRICE": "Change PRICE",
          DELETE: "DELETE",
          QTY: "QTY",
          "Are you sure to delete product :":
            "Are you sure to delete product :",
          Stock: "Stock",
          "Is Kit Item": "Is Kit Item",
          "Product Images": "Product Images",
          "More Info": "More Info",
          "File Name": "File Name",
          "File Size": "File Size",
          "File Type": "File Type",
          "File Category": "File Category",
          "View File": "View File",
          "Remove File": "Remove File",
          "Import Data ": "Import Data ",
          "Someting went wrong when processing the records":
            "Someting went wrong when processing the records",
          "Description is required": "Description is required",
          "Please add products before proceed":
            "Please add products before proceed",
          "Stock updated sucessfully": "Stock updated sucessfully",
          "Someting went wrong while save": "Someting went wrong while save",
          status: "status",
          "Change Type": "Change Type",
          "Description is Required": "Description is Required",
          "Reason description": "Reason description",
          "Payment Status": "Payment Status",
          "Invoice Amount": "Invoice Amount",
          "Invoice #": "Invoice #",
          "Is shipping manged by vendor": "Is shipping manged by vendor",
          "Shipping cost account mapping": "Shipping cost account mapping",
          "FOC QTY": "FOC QTY",
          "W/O Tax": "W/O Tax",
          "Create ": "Create ",
          "Return ": "Return ",
          "Local Purchase ": "Local Purchase ",
          "Darft entry created successfully":
            "Darft entry created successfully",
          "Not able to create draft entry": "Not able to create draft entry",
          "Invoice number is required": "Invoice number is required",
          Terms: "Terms",
          File: "File",
          "Cost W/O Tax": "Cost W/O Tax",
          "Reference No": "Reference No",
          "Total Quantity": "Total Quantity",
          "Without Tax": "Without Tax",
          "Total Tax": "Total Tax",
          "Total Amount": "Total Amount",
          "Discount Type": "Discount Type",
          "Discount Amount": "Discount Amount",
          "Shipping Cost": "Shipping Cost",
          "Shipping cost split view": "Shipping cost split view",
          "Goods return voucher": "Goods return voucher",
          "Goods receive note": "Goods receive note",
          "Purchase order got removed": "Purchase order got removed",
          "Not able to delete purchase order":
            "Not able to delete purchase order",
          "Generate Excel": "Generate Excel",
          REMOVE: "REMOVE",
          "Sale Date": "Sale Date",
          Transactions: "Transactions",
          "Error While Adding Product , please contact Support":
            "Error While Adding Product , please contact Support",
          "View Product Images": "View Product Images",
          "Total Discount": "Total Discount",
          "Hold No.": "Hold No.",
          "Invalid discount percentage": "Invalid discount percentage",
          "Discount limit is not configured!":
            "Discount limit is not configured!",
          "Error while fetching privileges!":
            "Error while fetching privileges!",
          "Something went wrong!": "Something went wrong!",
          "Login failed!": "Login failed!",
          "Pending Service ": "Pending Service ",
          "Service History": "Service History",
          Void: "Void",
          "Convert to Invoice": "Convert to Invoice",
          "Save Service Request": "Save Service Request",
          "Enable Excel Upload Feature in Purchase Order":
            "Enable Excel Upload Feature in Purchase Order",
          "Allow Day close with Hold Invoice":
            "Allow Day close with Hold Invoice",
          "Allow Zero Stock Sale": "Allow Zero Stock Sale",
          "Enable Save Option in Sales": "Enable Save Option in Sales",
          "Allow sale without customer": "Allow sale without customer",
          "Round off sale amount": "Round off sale amount",
          "Show Print Confirmation": "Show Print Confirmation",
          "Automatically Close Payment on Settle":
            "Automatically Close Payment on Settle",
          "Service Receipt": "Service Receipt",
          "OrderId/VoucherNumber": "OrderId/VoucherNumber",
          //PLACEHOLDER DO NOT DELETE
        }, //////////////// end
      },
    },
    lng: "en",
    fallbackLng: "en",

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
